var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShadowGpTlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1420_6227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.41935 19.9033L6.20246 20.8231H4.63623L5.41935 19.9033Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9325 19.9033L11.7156 20.8231H10.1494L10.9325 19.9033Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20.3924C0.710025 15.2154 1.42005 10.0374 2.13008 4.85872C2.26101 4.36754 2.7716 2.70119 4.4481 1.54322C5.95544 0.502527 7.50162 0.495159 8.08176 0.499457C8.61114 0.504369 10.1868 0.538138 11.5901 1.54322C12.8657 2.45622 13.6193 3.71365 13.7828 4.85872C14.5221 10.0362 15.2612 15.2141 16 20.3924C15.8847 20.5251 14.9663 21.543 13.4696 21.4976C11.8545 21.4485 10.9818 20.2052 10.901 20.0855C10.8189 20.2027 9.89232 21.4817 8.20706 21.4976C6.48232 21.5136 5.52504 20.1923 5.45049 20.0855C5.33835 20.231 4.3134 21.5087 2.56862 21.4976C1.09323 21.4884 0.165394 20.5637 0 20.3924Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7.5C9.65685 7.5 11 7.05228 11 6.5C11 5.94772 9.65685 5.5 8 5.5C6.34315 5.5 5 5.94772 5 6.5C5 7.05228 6.34315 7.5 8 7.5Z",
    fill: "rgba(253, 55, 7, 1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1420_6227",
    x1: 12.6865,
    y1: 7.31373,
    x2: 9.17943,
    y2: 3.26145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A1E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1420_6227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 21,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowGpTlogo);
export default __webpack_public_path__ + "static/media/ShadowGPTlogo.8667f9120807ebc5432c9a37b392e4ea.svg";
export { ForwardRef as ReactComponent };